import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import 'react-quill-new/dist/quill.snow.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';

import theme from './theme';

export default createGlobalStyle`
  ${reset};

  * {
    box-sizing: border-box;
    white-space: nowrap;
  }

  body {
    width: 100%;
    font-size: 15px;
    font-family: PretendardRegular, sans-serif;
    line-height: 1.6;
    background-color: ${theme.colors.whiteColor};
    scrollbar-width: none; // 파이어폭스
    -ms-overflow-style: none; // 익스플로러

    body::-webkit-scrollbar {
      display: none;
    }
  }

  a {
    color: ${theme.colors.blackColor};
    text-decoration: none;
  }

  textarea {
    resize: none;
  }

  input,
  textarea {
    font-family: PretendardRegular, sans-serif;
    border: none;
    outline: none;
    background-color: inherit;

    &::placeholder {
      font-size: 14px;
      font-family: PretendardRegular, sans-serif;
      color: ${theme.colors.deepGrayFontColor};
    }

    &:disabled {
      color: ${theme.colors.blackColor};
      background-color: ${theme.colors.lightGrayBorder};
    }
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  textarea:focus,
  input:focus {
    outline: none;
  }

  button {
    font-size: 15px;
    padding: 0;
    outline: none;
    border: none;
    background-color: transparent;
    font-family: PretendardRegular,  sans-serif;
    cursor: pointer;
  }

  select {
    font-size: 14px;
    border: none;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
  }

  li {
    list-style: none;
  }

  .Toastify__toast-container {
    width: 320px;
  }
  
  .Toastify__toast {
    line-height: 1.2;
    white-space: pre-wrap;
    word-break: keep-all !important;
  }
`;
